import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = ({ category, title, description, cta, image }) => {
  if (!title) {
    return null;
  }

  return (
    <section className="market-details-hero">
      {image ? (
        <img
          className="market-details-hero__graphic"
          src={image}
          alt=""
          aria-hidden="true"
        />
      ) : null}

      <div className="market-details-hero__inner">
        <div className="market-details-hero__copy">
          {category ? <p className="market-details-hero__eyebrow">{category}</p> : null}
          <h1 className="market-details-hero__title">{title}</h1>
          {description ? <p className="market-details-hero__text">{description}</p> : null}
          {cta?.text && cta?.url ? (
            <Link to={cta.url} className="market-details-hero__cta luxury-btn">
              {cta.text}
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default Hero;
